import OrdersList from '../Customer/OrdersList';

export default class SellerOrdersList extends OrdersList {
  urlPrefix = 'seller/';
}
